import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import {VoipPeerApiService} from '../../../../services/api/network/online/voip-peer/voip-peer-api.service';
import {ConnectionApiService} from '../../../../services/api/network/online/connection/connection-api.service';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {NetworkApiService} from '../../../../services/api/network/online/network/network-api.service';
import {DataItemToVisualsMappersService} from '../data-item-to-visuals-mappers/data-item-to-visuals-mappers.service';
import {map} from 'rxjs/operators';
import {DataCacheApiService} from '../data-cache-api/data-cache-api.service';
import {PeerConnectionApiService} from '../../../../services/api/peer-connection/peer-connection-api.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkMapApiService {

  constructor(private peerConnectionsApiService: PeerConnectionApiService,
              private voipPeersApiService: VoipPeerApiService,
              private connectionsApiService: ConnectionApiService,
              private nodesApiService: NodeApiService,
              private networkApiService: NetworkApiService,
              private dataItemToVisualsMappersService: DataItemToVisualsMappersService,
              private dataCacheApiService: DataCacheApiService) {}

  public getDataForShapes(parameters): any {
    const mergeShapes = (dataForShapes) => {
      const shapes = [];
      let shape;

      for (const node of dataForShapes.nodes) {
        shape = {};
        shape.dataItem = _.cloneDeep(node);
        shape.id = 'node_' + node.id;
        shape.shapeType = 'node';
        shape = this.dataItemToVisualsMappersService.prepareShapePropertiesForDiagram(shape);
        shapes.push(shape);
      }

      for (const voipPeer of dataForShapes.voipPeers) {
        shape = {};
        shape.dataItem = _.cloneDeep(voipPeer);
        shape.id = 'voippeer_' + voipPeer.id;
        shape.shapeType = 'voipPeer';
        shape = this.dataItemToVisualsMappersService.prepareShapePropertiesForDiagram(shape);
        shapes.push(shape);
      }
      return shapes;
    };

    const nodesForMap = this.nodesApiService.getNodesForMapNew(parameters, this.dataCacheApiService.getNodes());
    const voipPeersForMap = this.voipPeersApiService.getVoipPeersForMapNew(parameters, this.dataCacheApiService.getVoipPeers());

    return mergeShapes({
      nodes: nodesForMap,
      voipPeers: voipPeersForMap
    });
  }

  public getDataForConnections(parameters): any {
    const mergeConnections = (dataForConnections) => {
      const connections = [];
      let connection;

      for (const con of dataForConnections.connections) {
        connection = {};
        connection.dataItem = _.cloneDeep(con);
        connection.id = 'connection_' + con.id;
        connection.connectionType = 'connection';
        connection = this.dataItemToVisualsMappersService.prepareConnectionPropertiesForDiagram(connection);
        connections.push(connection);
      }

      for (const pCon of dataForConnections.pCons) {
        connection = {};
        connection.dataItem = _.cloneDeep(pCon);
        connection.id = 'peerConnection_' + pCon.id;
        connection.connectionType = 'peerConnection';
        connection = this.dataItemToVisualsMappersService.prepareConnectionPropertiesForDiagram(connection);
        connections.push(connection);
      }
      return connections;
    };

    const connectionssForMap = this.connectionsApiService.getConnectionsForMapNew(parameters, this.dataCacheApiService.getConnections());
    const pconsForMap = this.peerConnectionsApiService.getPConsForMapNew(parameters, this.dataCacheApiService.getPcons());

    return mergeConnections({
      connections: connectionssForMap.elements,
      pCons: pconsForMap.elements
    });

  }

  public getClusters(): any {
    return this.dataItemToVisualsMappersService.prepareClustersPropertiesForDiagram(this.dataCacheApiService.getClusters());
  }

  public updateShapesLocation(draggedShapes, clusters): Promise<any> {
    return Promise.all([this.nodesApiService.moveNodes(draggedShapes.nodes),
      this.voipPeersApiService.moveVoipPeers(draggedShapes.voipPeers),
      this.networkApiService.saveClustersStateToServer(clusters)]);
  }
}
